import { Dialog } from '@headlessui/react'

import XIcon from '@Icons/x-close-filter.svg?react'
import { useRemoveUrlDispatch } from '@Utils/context/modal/useRemoveUrl'

function RemoveUrlModal(): JSX.Element {
  const { close, onApply } = useRemoveUrlDispatch()

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{
        background: 'rgba(41, 41, 41, 0.7)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Dialog.Panel className="relative border rounded-xl shadow-xl bg-white-100 sm:w-2/3 md:w-1/2 lg:w-1/3 xl:w-1/4 w-full">
        <div className="flex flex-col p-6 items-center">
          <button
            className="absolute right-8 active:bg-gray-50 border-0 p-2 rounded-full"
            onClick={close}
          >
            <XIcon />
          </button>
          <h1 className="font-medium text-lg text-gray-900 mt-5">
            Please Confirm
          </h1>
          <p className="font-normal text-sm text-gray-500 mt-2 text-center">
            Are you sure deleting URL ?
          </p>

          <div className="flex flex-row mt-8 w-full">
            <button
              onClick={close}
              className="border border-solid border-gray-300 shadow-sm rounded-lg py-2.5 px-3 w-1/3 mr-1.5 active:bg-gray-100"
            >
              <span className="font-medium text-base text-gray-700 ">
                Cancel
              </span>
            </button>
            <button
              type="button"
              onClick={onApply}
              className="border border-solid border-error-600 bg-error-600 active:bg-error-700 shadow-sm rounded-lg py-2.5 px-3 w-2/3 ml-1.5"
            >
              <span className="font-medium text-base text-white-100 ">
                Delete
              </span>
            </button>
          </div>
        </div>
      </Dialog.Panel>
    </div>
  )
}

export default RemoveUrlModal
